<div class="row_1">
    <label class="label tab-heading titlered">Detail Level</label>

    <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
        Queue</button>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <div class="row col-12">
            <div class="col-2">
                <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="refreshData()"
                    style="margin-top: 6%;">
                <label class="drpdwn_period_label"> Period : {{ PeriodLabel }}</label>
            </div>
            <div class="col-10" style="text-align: center;margin-top: 0.4%;">
                <textarea  class="textAreaComment" rows="2"
                    placeholder="Comment (minimum length 10 characters)" [(ngModel)]="tAddViewComments"></textarea>
                <label class="catlabel" >Comments</label>
            </div>
        </div>
        <div style="text-align:center;font-size: 18px;margin-top: 0.6%;">
            <label class="label titlered">{{tierTitle}} -&nbsp; </label>
            <label class="label"> {{routeTitle}}</label>
        </div>
        <div class="checkBoxOperations">
            <input type="checkbox" id="complete" class="customCheckbox" [(ngModel)]="toggleShowComplete"
                style="margin-left: 1%;" (click)="updateDisplayRowDataCB('complete')">
            <label for="complete" class="customCheckboxLabel">Show Complete</label>
            <input type="checkbox" id="ignore" class="customCheckbox" [(ngModel)]="toggleShowIgnore"
                style="margin-left: 4%;" (click)="updateDisplayRowDataCB('ignore')">
            <label for="ignore" class="customCheckboxLabel">Show Ignore</label>

            <span *ngIf="shouldHide">
                <img src="./assets/images/vertical_line.svg" class="vertical-line">
                <label class="label linkLabel">Complete:</label>
                <label class="linkAll" (click)="optimisedUpdateRowData('completed','all')"
                    [ngStyle]="{'color' : linkModule=='completedall'?'blue':'black'}">All</label>
                <label class="linkNone" (click)="optimisedUpdateRowData('completed','none')"
                    [ngStyle]="{'color' : linkModule=='completednone'?'blue':'black'}">None</label>
                <img src="./assets/images/vertical_line.svg" class="vertical-line">
                <label class="label linkLabel">Ignore:</label>
                <label class="linkAll" (click)="optimisedUpdateRowData('ignored','all')"
                    [ngStyle]="{'color' : linkModule=='ignoredall'?'blue':'black'}">All</label>
                <label class="linkNone" (click)="optimisedUpdateRowData('ignored','none')"
                    [ngStyle]="{'color' : linkModule=='ignorednone'?'blue':'black'}">None</label>

                <!-- <img src="./assets/images/vertical_line.svg" class="vertical-line">
                <label class="linkAll" [ngStyle]="{'color' : 'black'}" style="margin-left: 0;"
                    (click)="verificationStatus();">Verification</label> -->
            </span>
        </div>
        <div class="grid-agg">
            <ag-grid-angular style="width:100%;height:400px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
                [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="displayRowData"
                  [context]="context" [pagination]="true" [paginationPageSize]="rowCount"
                [icons]="icons" [gridOptions]="gridOptions">
            </ag-grid-angular>
            <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                <div class="w-25 col-4 ">
                    <div>
                        <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                        <select class="page-drpdwn" (change)="onPageSizeChanged($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="ALL" selected>ALL</option>
                        </select>
                        <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
                    </div>
                </div>

                <div style="display: flex;" class="pagination_text col-4 offset-2">

                    <!-- first -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                        [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                        first_page</mat-icon>

                    <!-- previous -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
                        [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                        keyboard_arrow_left</mat-icon>

                    <p class="total_row_text">Total Row {{rowCount}}</p>

                    <!-- next -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                        (click)="goToNexpage()">keyboard_arrow_right
                    </mat-icon>

                    <!-- last -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                        (click)="goToLastPage()">last_page
                    </mat-icon>

                </div>

            </div>

        </div>
        <div>
            <button class="primarybutton" style="margin:0 1% 1% 4%" (click)="goBack();">BACK</button>
            <button class="primarybutton" style="float: right;margin:0 4% 1% 1%" (click)="saveDetails();"
                *ngIf="shouldHide && mustHide">SAVE</button>
        </div>
    </div>
</div>